var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 5.77295V18.6628C3.3125 19.7115 4.17061 20.5696 5.21941 20.5696H18.5773C19.6261 20.5696 20.4843 19.721 20.4843 18.6723V11.5696C20.5033 9.39583 18.749 7.64159 16.5751 7.64159H14.5782",
    stroke: "#EC5F2A",
    strokeWidth: 1.43014,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11626 4H10.6082C12.6104 4 14.2408 5.6303 14.2408 7.63242H5.11626C4.11513 7.63242 3.30469 6.82203 3.30469 5.82097C3.30469 4.81992 4.11513 4 5.11626 4Z",
    stroke: "#EC5F2A",
    strokeWidth: 1.43014,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.837 16.4989C18.6071 16.4989 17.625 15.4979 17.625 14.268C17.625 13.0381 18.6261 12.0562 19.8561 12.0562",
    stroke: "#EC5F2A",
    strokeWidth: 1.43014,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIconActive);
export default __webpack_public_path__ + "static/media/paymentIconActive.8347924ed683e31b48a8cd9fe0e46a17.svg";
export { ForwardRef as ReactComponent };